// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import CamerasDashboard from './CamerasDashboard';

export default compose(
  connect(
    state => ({
      app: state.app
    }),
    dispatch => ({}),
  ),
)(CamerasDashboard);
